import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=124e0cb2&scoped=true"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"
import style0 from "./LineChart.vue?vue&type=style&index=0&id=124e0cb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e0cb2",
  null
  
)

export default component.exports